<template>
  <div class="px-3 pt-2 h-full overflow-auto pb-5">
    <div class="text-11 text-gray-400 mb-3">The agent will invoke this workflow as a tool and receive its response.</div>
    <FormSelect v-model="payload.flow_id" :options="flowOptions" label="Workflow to Invoke" class="w-full" append-to-body default-reducer clearable @update:modelValue="emitPayload" />
    <VariableSelect
      v-model="payload.data_binding"
      multiple
      label="Pass Variables to Workflow"
      class="mt-3"
      selectBgColor="bg-white"
      :filter-data-type="['Text', 'Number', 'DataTable', 'Chart', 'Date']"
      :showCreate="false"
      @update:modelValue="emitPayload"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EvaluateItemsConfig from './EvaluateItemsConfig';
import debounce from '../../../helpers/debounce';

export default {
  name: 'FlowInvokeConfig',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      payload: structuredClone(EvaluateItemsConfig['action-invoke-flow'].payload),
    };
  },
  computed: {
    ...mapGetters(['getProjectFlows']),
    flowOptions() {
      return Object.values(this.getProjectFlows())
        .filter((f) => f.flowType !== 'Agent')
        .map((f) => ({ label: f.name, value: f.flow_id }));
    },
  },
  methods: {
    // eslint-disable-next-line
    emitPayload: debounce(function () {
      this.$emit('update', {
        id: this.item.id,
        type: this.item.type,
        payload: this.payload,
      });
    }, 300),
  },
  watch: {
    item: {
      handler() {
        if (this.item) {
          this.payload = { ...structuredClone(EvaluateItemsConfig['action-invoke-flow'].payload), ...JSON.parse(JSON.stringify(this.item.payload)) };
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
